module.exports = __webpack_public_path__ + "static/media/error-icon.4c76e560.svg";